import { Lightning } from '@lightningjs/sdk'
import { getColor, grey50 } from '../../constants/colors'
import { UniNeueRegular } from '../../constants/fonts'
import { Images } from '../../constants/paths'
import { getAsset } from '../../utils/image'

export default class ProductBullet extends Lightning.Component {
  static _template() {
    return {
      flexItem: {
        marginTop: 40,
      },
      flex: {
        direction: 'row',
      },
      Icon: {
        flexItem: {
          marginTop: 3,
        },
        texture: Lightning.Tools.getSvgTexture(getAsset(Images.SIGN_UP_PRODUCT_INFO_CHECK), 36, 36),
      },
      Info: {
        flexItem: {
          marginLeft: 16,
        },
        w: 884,
        text: {
          text: '',
          textColor: getColor(grey50),
          fontSize: 32,
          lineHeight: 36,
          fontFace: UniNeueRegular,
          maxLines: 3,
        },
      },
    }
  }

  set infoText(v: string) {
    this.tag('Info').text.text = v
  }
}
